import React, { useEffect } from 'react';

export default function SaveLoader({ setIsLoading, isLoading }) {
    // const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // When isLoading becomes true, run the save flow here.
        // This keeps the effect self-contained so we don't depend on an external handler.
        if (isLoading) {
            setIsLoading(true);
            const timer = setTimeout(() => {
                setIsLoading(false);
                // alert('Saved successfully!');
            }, 3000);

            // Cleanup if the component unmounts or isLoading changes
            return () => clearTimeout(timer);
        }
        // no cleanup needed when not saving
        return undefined;
    }, [isLoading, setIsLoading]);


    return (
        <>
            <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .page-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }

        .save-button {
          padding: 18px 48px;
          font-size: 18px;
          font-weight: 600;
          color: white;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 50px;
          cursor: pointer;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
          transition: all 0.3s ease;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .save-button:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
        }

        .save-button:active:not(:disabled) {
          transform: translateY(-1px);
        }

        .save-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .loader-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.7);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .loader-container {
          background: white;
          border-radius: 24px;
          padding: 50px 40px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
          text-align: center;
          max-width: 400px;
          animation: scaleIn 0.4s ease;
        }

        @keyframes scaleIn {
          from {
            transform: scale(0.8);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }

        .spinner-wrapper {
          position: relative;
          width: 100px;
          height: 100px;
          margin: 0 auto 30px;
        }

        .spinner-ring {
          position: absolute;
          width: 100%;
          height: 100%;
          border: 4px solid #f3f4f6;
          border-radius: 50%;
        }

        .spinner-ring-1 {
          border-top-color: #667eea;
          animation: spin 1.2s linear infinite;
        }

        .spinner-ring-2 {
          width: 80%;
          height: 80%;
          top: 10%;
          left: 10%;
          border-top-color: #764ba2;
          animation: spin 1s linear infinite reverse;
        }

        .spinner-ring-3 {
          width: 60%;
          height: 60%;
          top: 20%;
          left: 20%;
          border-top-color: #f093fb;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .spinner-wrapper::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20px;
          height: 20px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 50%;
          animation: pulse 1.5s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
          50% {
            transform: translate(-50%, -50%) scale(1.5);
            opacity: 0.5;
          }
        }

        .loader-title {
          font-size: 28px;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 12px;
        }

        .loader-subtitle {
          font-size: 16px;
          color: #6b7280;
          margin-bottom: 25px;
        }

        .warning-box {
          background: #fef3c7;
          border: 2px solid #fbbf24;
          border-radius: 12px;
          padding: 16px;
          display: flex;
          align-items: flex-start;
          gap: 12px;
          margin-bottom: 25px;
        }

        .warning-icon {
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          background: #f59e0b;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 18px;
        }

        .warning-text {
          color: #92400e;
          font-weight: 600;
          font-size: 14px;
          text-align: left;
        }

        .dots-container {
          display: flex;
          justify-content: center;
          gap: 8px;
        }

        .dot {
          width: 10px;
          height: 10px;
          background: #667eea;
          border-radius: 50%;
          animation: bounce 1.4s ease-in-out infinite;
        }

        .dot:nth-child(1) {
          animation-delay: 0s;
        }

        .dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes bounce {
          0%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-20px);
          }
        }
      `}</style>

            <div  >
                {/* <button
                    className="save-button"
                    onClick={handleSave}
                    disabled={isLoading}
                >
                    {isLoading ? 'Saving...' : 'Save'}
                </button> */}

                {isLoading && (
                    <div className="loader-overlay">
                        <div className="loader-container">
                            <div className="spinner-wrapper">
                                <div className="spinner-ring spinner-ring-1"></div>
                                <div className="spinner-ring spinner-ring-2"></div>
                                <div className="spinner-ring spinner-ring-3"></div>
                            </div>

                            <h2 className="loader-title">Please Wait</h2>
                            <p className="loader-subtitle">Saving your data...</p>

                            <div className="warning-box">
                                <div className="warning-icon">!</div>
                                <p className="warning-text">Don't cancel or close this window</p>
                            </div>

                            <div className="dots-container">
                                <div className="dot"></div>
                                <div className="dot"></div>
                                <div className="dot"></div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}